<template>
   <div class="loans-pipeline__container">
     <conds :all-conditions="conditionsData" :loanid="selectedLoan" :loan-number="selectedLoanNumber" :borrower="selectedLoanBorrower" v-on:conditionsupdated="efolder"></conds>
   </div>
</template>

<script>
    import { Window } from '@progress/kendo-vue-dialogs';
    import { Button } from '@progress/kendo-vue-buttons';
    import auth from '../authConfig.js';
    import axios from 'axios';
    import conditions from '../components/Conditions.vue';
    import apiService from '../api/api.service.js';
    import formatHelpers from '../helpers/formatHelpers.js';

    export default {
        name: 'App',
        components: {
            'conditionwindow':conditions,
            'window': Window,
            'kbutton': Button,
            "conds": conditions
        },
        data() {
            return {
                conditionsData:[],
                selectedLoan:'',
                selectedLoanBorrower: '',
                selectedLoanNumber: '',
                isLoading: true,
                visible: true,
                isError: false,
                loaderStatus: "Logging In",
                loandata:[], 
                idTokenClaims: null,
            }
        },       
        async created() {
            this.selectedLoan = sessionStorage.getItem('selectedloan');

            const msalAppInstance = await auth.init();
                
            msalAppInstance.handleRedirectPromise().then(async (tokenRes) => {

                if (!tokenRes) {
                    if (!auth.user()) {
                        auth.login();
                    } 
                }

                await this.getLoan();
                this.efolder();
            });
        },
        methods: {
            async efolder(update = false){
                let conditions = this.$store.state.conditions;

                if (conditions.length > 0 && !update) return this.conditionsData =  conditions.map(cond => ({...cond}));

                await this.$store.dispatch('getConditions');
                this.conditionsData = this.$store.state.conditions.map(cond => ({...cond}));
                
                this.isLoading = false;       
            },
            async getLoan() {
                this.selectedLoanNumber = sessionStorage.getItem('loannumber');
                this.selectedLoanBorrower = sessionStorage.getItem('loanborrower');

                if (this.selectedLoanNumber && this.selectedLoanBorrower) return document.title = this.selectedLoanBorrower;

                await this.$store.dispatch('updateLoan');

                this.selectedLoanNumber = sessionStorage.getItem('loannumber');
                this.selectedLoanBorrower = sessionStorage.getItem('loanborrower');
                this.loanChange = false;

                document.title = this.selectedLoanBorrower;
            }
        }  
             
    }
</script>

<style>
    .swift-middle{
    display: flex;
    width:30%
    }

    body,
    body {
        /* Body font-size approx 16px */
        font-size: 14px;
        overflow: hidden;
    }

    p {
        display: block;
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0;
        margin-inline-end: 0;
    }

    [type=reset], [type=submit], button, html [type=button] {
        -webkit-appearance: button;
    }

    button, input {
        overflow: visible;
    }

    button, input, optgroup, select, textarea {
        margin: 0;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
    }

    .card__wrapper {
        position: relative;
        height: 100vh;
        overflow: scroll;
        max-width: 73rem;
        margin: auto;
        padding: 2rem;
        background-color: #fff;
        overflow-y: hidden;
        overflow-x: hidden;
    }

    .card__body {
        overflow-y: scroll;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        padding: 2.5rem 2.5rem 30rem 5rem;
        height: calc(100% - 40.3rem);
        transition: all .1s linear;
        margin-top: 0.8rem;
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .card__body::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    .card__body {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    .notes__header h1 {
        text-align: right;
        font-family: cursive;
        font-size: 2.5rem;
        font-weight: 500;
        letter-spacing: -0.09rem;
        color: #525252;
        margin-top: 0;
        width: 110%;
    }

    .card__header {
        position: relative;
        bottom: 0;
        background-color: white;
        width: 100%;
        z-index: 3;
    }

    .status-text {
        font-family: Arial;
        font-weight: 600;
        margin: 0;
        text-align: center;
        font-size: 3rem;
        color: #051d3a;
        font-size: 3rem;
        white-space: pre-wrap;
    }

    .label-text {
        display: block;
        font-size: 1.2rem;
        font-weight: 300;
        margin: 0;
        text-align: center;
        color: gray;
    }

    .message-header-text {
        float: right;
        margin-top: -2.3rem;
        overflow-x: visible;
        white-space: nowrap;
    }

    .name-text {
        color: rgb(101 101 101);
        font-weight: 600;
    }

    .date-text {
        font-size: 1.2rem;
    }

    .note-textinput {
        flex: 1 0 100px;
        width: 100%;
        height: fit-content;
        font-family: Arial, sans-serif;
        font-size: 1.6rem;
        padding: 0.6rem 1.2rem;
        color: black;
        background: transparent;
        border: 1px solid #ccced1;
        border-radius: 1rem;
        outline: 0;
        box-shadow: none;
        white-space: pre-wrap;
        resize: none;
        background-color: white;
        overflow-y: hidden;
        transition: height .1s linear;
    }

    .note-textinput:hover {
        border-bottom: 1px solid #34485f;
    }

    .note-textinput::placeholder {
        font-family: "Montserrat";
        margin: 0;
        letter-spacing: -0.02rem;
    }

    .ckeditor__wrapper {
        z-index: 5;
        width: 100%;
        flex: 1 0;
    }

    .note-entry {
        word-wrap: break-word;
        margin-bottom: 2.5rem;
        font-size: 1.4rem;
        line-height: 122%;
        position: relative;
        padding: 0.7rem 1.3rem;
        border-radius: 1rem;
        max-width: 80%;
        min-height: 4rem;
    }

    .note-entry::before,
    .note-entry::after {
        content: "";
        position: absolute;
        bottom: 0;
        height: 2.5rem;
    }

    .note-entry__pfp {
        position: absolute;
        left: -5rem;
        bottom: 0;
        z-index: 2;
    }

    .note-entry__pfp img {
        border-radius: 1000px;
        width: 4rem;
        height: 4rem;
    }

    .from-user {
        color: white;
        background: #0B93F6;
        align-self: flex-end;
    }

    .from-user::before {
        right: -.7rem;
        width: 2rem;
        background-color: #0B93F6;
        border-bottom-left-radius: 1.6rem 1.4rem;
    }

    .from-user::after {
        right: -2.6rem;
        width: 2.6rem;
        background-color: white;
        border-bottom-left-radius: 1rem;
    }

    .from-others {
        background: #E5E5EA;
        color: black;
        align-self: flex-start;
    }

    .from-others > .message-header-text {
        float: left;
    }

    .from-others::before {
        left: -0.7rem;
        width: 2rem;
        background-color: #E5E5EA;
        border-bottom-right-radius: 1.6rem 1.4rem;
    }

    .from-others::after {
        left: -2.6rem;
        width: 2.6rem;
        background-color: white;
        border-bottom-right-radius: 1rem;
    }

    .header-bar {
        align-items: center;
        display: flex;
        flex-direction: row;
        gap: .5rem;
        flex-wrap: wrap;
    }

    .send-btn {
        display: inline-block;
        align-self: start;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        height: 3.2rem;
        margin-left: auto;
        font-size: 1.6rem;
        line-height: 1.5;
        border-radius: 1rem;
        background-color: #051d3a;
        color: #fff;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    .send-btn:disabled {
        background-color: #b2b7bb;
    }

    .send-btn:not(:disabled):hover {
        cursor: pointer;
        background-color: #34485f;
    }

    .loader-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 25vh;
    }

    .submission-loader__wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #e5e5e5a3;
        z-index: 3;
        inset: 0;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
    }

    .loading__inlineLoader {
        margin-top: 3rem;
    }

    .loading__inlineLoader:after {
        content: " ";
        display: block;
        width: 5.5rem;
        height: 5.5rem;
        margin: 0.8rem;
        border-radius: 50%;
        border-color: #051d3a transparent;
        border-style: solid;
        border-width: 0.5rem;
        -webkit-animation: inline-loader 1.2s linear infinite;
        animation: inline-loader 1.2s linear infinite
    }

    @-webkit-keyframes inline-loader {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg)
        }

        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    @keyframes inline-loader {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg)
        }

        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    @media only screen and (max-width: 500px) and (orientation: portrait) {
      body {
        overflow: unset;
      }
    }


    /* Transitions */
    .fade-enter-active,
    .fade-leave-active {
        transition: all .2s;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    /* CKEditor */
    :root {
        --ck-border-radius: 1rem;
        --ck-color-focus-border: #34485f;
        --ck-font-size-base: 1.3rem;
    }
</style>
